import { ChangeDetectionStrategy, Component, input, Type } from '@angular/core';
import { NgClass, NgComponentOutlet } from '@angular/common';
import {
  TranslocoFunction,
  WizardFooterInterface,
  WizardStepInterface,
} from '../../types';
import { AbsoluteUrlPipe } from '@core-utils';

@Component({
  selector: 'ui-wizard',
  imports: [NgClass, NgComponentOutlet, AbsoluteUrlPipe],
  templateUrl: './wizard.component.html',
  styleUrl: './wizard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardComponent {
  logoUrl = input<string>('./assets/media/main/logo.png');
  currentStep = input<number>(0);
  steps = input<WizardStepInterface[]>([]);
  footerLinks = input<WizardFooterInterface[]>([]);
  component = input.required<Type<unknown>>();
  t = input<TranslocoFunction>();
}
